// Search Service API Client
import axios from 'axios';

// Search service base URL - can be configured via environment variable
export const searchServiceURL = process.env.REACT_APP_SEARCH_SERVICE_URL || 'https://search-service-762667531133.europe-west1.run.app';

// Create axios instance for search service (no auth required for Phase 1)
export const searchClient = axios.create({
  baseURL: searchServiceURL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Search request parameters
export interface ISearchParams {
  q: string;
  type?: 'recipe' | 'batch' | 'suggestedBatch' | 'all';
  status?: 'published' | 'draft' | 'all';
  page?: number;
  limit?: number;
  sort?: 'relevance' | 'name' | 'date';
}

// Individual search result
export interface ISearchResult {
  id: string;
  type: 'recipe' | 'batch' | 'suggestedBatch';
  name: string;
  description?: string;
  status?: string;
  score: number;
  thumbnail?: string;
  createdDate?: string;
  updatedDate?: string;
}

// Search response
export interface ISearchResults {
  results: ISearchResult[];
  total: number;
  page: number;
  limit: number;
  query: string;
}

// Main search function
export const searchGlobal = async (params: ISearchParams): Promise<ISearchResults> => {
  try {
    console.log('🌐 Search API request:', {
      url: `${searchServiceURL}/v1/search`,
      params: params
    });
    const response = await searchClient.get('/v1/search', { params });
    console.log('📥 Search API response:', {
      total: response.data.total,
      resultsCount: response.data.results.length,
      query: response.data.query,
      statuses: response.data.results.map(r => r.status)
    });
    return response.data;
  } catch (error) {
    console.error('Search error:', error);
    if (axios.isAxiosError(error)) {
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
    }
    throw error;
  }
};

// Health check function
export const searchHealthCheck = async (): Promise<{ status: string; service: string; timestamp: string }> => {
  try {
    const response = await searchClient.get('/v1/health');
    return response.data;
  } catch (error) {
    console.error('Search health check error:', error);
    throw error;
  }
};
